import * as yup from 'yup';

export const patientValidationSchma = {
  name: yup
    .string()
    .min(4, 'Too Short Name!')
    .max(50, 'Too Long Name!')
    .required('Fullname is required!'),
  email: yup.string().email().required('Email address is required!'),
  fileID: yup.string(),
  birthdate: yup.string().required('Birthdate is required!'),
  gender: yup.string().required('Gender is required!')
};

export const patientCreateValidationSchma = {
  name: yup
    .string()
    .min(4, 'Too Short Name!')
    .max(50, 'Too Long Name!')
    .required('Fullname is required!'),
  email: yup.string().email().required('Email address is required!'),
  password: yup.string().required('Password is required!'),
  fileID: yup.string(),
  birthdate: yup.string().required('Birthdate is required!'),
  gender: yup.string().required('Gender is required!')
};

export const goalsValidationSchma = yup
  .object()
  .shape({
    date: yup
      .date()
      .required('Date is required')
      .max(new Date(), 'Date cannot be in the future'),
    hba1c: yup.number().nullable(),
    weight: yup.number().nullable()
  })
  .test(
    'at-least-one',
    'At least one of HbA1C or weight must be provided',
    value => {
      if (value.hba1c == null && value.weight == null) {
        return new yup.ValidationError(
          'At least one of HbA1C or weight must be provided',
          value,
          'HBA1C'
        );
      }
      return true;
    }
  );

export const goalProgressValidationSchema = yup.object().shape({
  date: yup
    .date()
    .required('Date is required')
    .max(new Date(), 'Date cannot be in the future'),
  progress_value: yup
    .number()
    .required('Current value is required')
    .when('type', {
      is: 'weight',
      then: schema =>
        schema
          .min(20, 'Current weight must be at least 20 kg')
          .max(400, 'Current weight must not exceed 400 kg'),
      otherwise: schema =>
        schema
          .min(3, 'Current HbA1C must be at least 3%')
          .max(20, 'Current HbA1C must not exceed 20%')
    }),
  type: yup.string().required(),
  goal: yup.string().required(),
  unit: yup.string().required()
});
